import isNil from 'lodash/isNil';
import { call, delay, put, select } from 'redux-saga/effects';

import * as SampleConstants from '../constants';
import * as D from '../deps';
import * as SampleUtils from '../utils';

import * as SampleWorkers from './workers';

const spawn = D.taskManagerSpawnFactory(SampleConstants.DOMAIN_NAME);

export function* watchPlaySample(action) {
  const sampleAction = action.type === D.Constants.Samples.SamplePlayerActions.PLAY ? action : null;
  if (sampleAction) {
    const resumeTrackOnEnd = sampleAction.data.resumeTrackOnEnd;
    if (!resumeTrackOnEnd) {
      // if we don't get a resumeTrackOnEnd, figure out whether we should resume
      if (isNil(sampleAction.data.resumeTrackOnEnd)) {
        const isTrackPlaying = yield select(D.AudioUtils.isAudioPlayerPlaying);
        const shouldResumeTrack = yield select(SampleUtils.getShouldResumeTrack);

        sampleAction.data.resumeTrackOnEnd = isTrackPlaying || shouldResumeTrack;
      }
    } else {
      sampleAction.data.resumeTrackOnEnd = resumeTrackOnEnd;
    }
    yield call(SampleWorkers.playSingleSample, sampleAction);
    yield delay(250);
  } else {
    yield put(D.Actions.SamplePlayer.shouldResumeTrack(null));
  }
}

export function* watchPlaySamples(action) {
  yield spawn(SampleWorkers.handlePlaySamples, action);
}
